/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import Typography from '@material-ui/core/Typography';

import { ICustomTheme } from 'interfaces';
import { useTheme } from '@material-ui/core';

type Theme = {
  theme?: ICustomTheme;
};

const WarningContainer = styled('div')<Theme>(({ theme }) => ({
  backgroundColor: `${theme.colors.error.main}55`,
  padding: theme.spacing(3),
  color: theme.colors.grey.dark,
  fontSize: theme.typography.body2.fontSize,
}));

const Rejection = styled(Typography)<Theme>(({ theme }) => ({
  marginTop: theme.spacing(4),
  wordBreak: 'break-word',
}));

export default function WarningTextDeclarationRefused({
  rejectionText,
}: {
  rejectionText: string;
}): JSX.Element {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();

  return (
    <WarningContainer>
      <Typography css={{ fontWeight: theme.typography.fontWeightBold }}>
        {t('challenges.declaration.history.refused_declaration')}
      </Typography>
      {t('challenges.declaration.history.refused_precision')}
      <Rejection>{rejectionText}</Rejection>
    </WarningContainer>
  );
}
